import { render, staticRenderFns } from "./BootStrap.vue?vue&type=template&id=2b7d73f8"
var script = {}
import style0 from "./BootStrap.vue?vue&type=style&index=0&id=2b7d73f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports